import InboxMembersAPI from '../../api/inboxMembers';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getInboxMembers: _state => inboxId => {
    return _state.records[inboxId] || null;
  },
  getAgentIdsByInbox: _state => inboxId => {
    const inboxData = _state.records[inboxId];
    return inboxData?.agent_ids || [];
  },
  getAgentsByInbox: _state => inboxId => {
    const inboxData = _state.records[inboxId];
    return inboxData?.agents || [];
  },
  getVoiceConfigByInbox: _state => inboxId => {
    const inboxData = _state.records[inboxId];
    return inboxData?.voice_config || null;
  },
};

export const mutations = {
  SET_INBOX_MEMBERS_UI_FLAG(_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  SET_INBOX_MEMBERS(_state, { inboxId, data }) {
    _state.records = {
      ..._state.records,
      [inboxId]: data,
    };
  },
  CLEAR_INBOX_MEMBERS(_state, inboxId) {
    const { [inboxId]: _, ...rest } = _state.records;
    _state.records = rest;
  },
};

export const actions = {
  async get({ commit }, { inboxId }) {
    commit('SET_INBOX_MEMBERS_UI_FLAG', { isFetching: true });
    try {
      const response = await InboxMembersAPI.show(inboxId);
      commit('SET_INBOX_MEMBERS', {
        inboxId,
        data: response.data?.data || response.data,
      });

      console.log('[InboxMembers Store] GET response:', response.data);

      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_INBOX_MEMBERS_UI_FLAG', { isFetching: false });
    }
  },

  async update({ commit }, { inboxId, agentIds }) {
    commit('SET_INBOX_MEMBERS_UI_FLAG', { isUpdating: true });
    try {
      console.log('[InboxMembers Store] UPDATE payload:', { inboxId, agentIds });
      
      const response = await InboxMembersAPI.update({ inboxId, agentIds });
      
      commit('SET_INBOX_MEMBERS', {
        inboxId,
        data: response.data?.data || response.data,
      });
      
      console.log('[InboxMembers Store] UPDATE response:', response.data);
      
      return response;
    } catch (error) {
      console.error('[InboxMembers Store] UPDATE error:', error);
      throw error;
    } finally {
      commit('SET_INBOX_MEMBERS_UI_FLAG', { isUpdating: false });
    }
  },

  clearInboxMembers({ commit }, inboxId) {
    commit('CLEAR_INBOX_MEMBERS', inboxId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};